import { useEffect, useRef, useState } from "react";
import { getInternalPocoTeamDetails, getAllCompany } from "../../pages/actions/actions";
import { useQuery } from "@tanstack/react-query";

export const UseTicketFilter = (filterDate: any) => {
  const btnRef: any = useRef(null);
  // default height
  // const [pocoTeamData, setPocoTeamData] = useState<any>([]);
  const initialTicketId = sessionStorage.getItem("ticketId") || "";
  const initialAgentName = sessionStorage.getItem("agentName") || "";
  const initialTo = sessionStorage.getItem("dateFrom") || "";
  const initialFrom = sessionStorage.getItem("dateTo") || "";
  const initialStatus = sessionStorage.getItem("ticketStatus") || "";
  const initialCompanyId = sessionStorage.getItem("companyId") || "";
  const initialCaseStudies = sessionStorage.getItem("hasCaseStudies") === "true";
  const initialCallerID = sessionStorage.getItem("callerID") || "";
  //eslint-disable-next-line
  const [filterCriteria, setFilterCriteria] = useState<{
    ticketId: string;
    dateFrom: string;
    dateTo: string;
    agentName: string;
    ticketStatus: string;
    companyId: string;
    hasCaseStudies: boolean;
    callerID: string;
  }>({
    ticketId: initialTicketId || "",
    dateFrom: initialFrom || "",
    dateTo: initialTo || "",
    agentName: initialAgentName || "",
    ticketStatus: initialStatus || "",
    companyId: initialCompanyId || "",
    hasCaseStudies: initialCaseStudies || false,
    callerID: initialCallerID || "",
  });

  const handleTicketID = (ticketId: string) => {
    setFilterCriteria((prev) => ({
      ...prev,
      ticketId: ticketId,
    }));
  };

  const handleCallerID = (callerID: string) => {
    setFilterCriteria((prev) => ({
      ...prev,
      callerID: callerID,
    }));
  };

  const handleSendDate = (data: any) => {
    setFilterCriteria((prev) => ({
      ...prev,
      dateFrom: data.from,
      dateTo: data.to,
    }));
  };

  const handleGetTicketStatus = (data: any) => {
    setFilterCriteria((prev) => ({
      ...prev,
      ticketStatus: data,
    }));
  };

  const handleSelectAgent = (data: any) => {

    setFilterCriteria((prev) => ({
      ...prev,
      agentName: data,
    }));
  };

  const handleSelectCompany = (data: any) => {
    setFilterCriteria((prev) => ({
      ...prev,
      companyId: data,
    }));
  };

  const handleCaseStudiesToggle = (checked: boolean) => {
    setFilterCriteria((prev) => ({
      ...prev,
      hasCaseStudies: checked,
    }));
  };

  const handleClearFilter = () => {
    setFilterCriteria({
      ticketId: "",
      dateFrom: "",
      dateTo: "",
      agentName: "",
      ticketStatus: "",
      companyId: "",
      hasCaseStudies: false,
      callerID: "",
    });
    handleClearDate();
  };

  const handleClearDate = () => {
    if (btnRef?.current) {
      let clear = btnRef?.current.querySelector(".ant-picker-clear");
      if (clear) {
        clear.click();
      }
    }
  };

  const { data } = useQuery({
    queryKey: ["agentData"],
    queryFn: getInternalPocoTeamDetails,
    select: (data: any) => {
      return (Array.isArray(data?.agentsforFilter) && data?.agentsforFilter?.length > 0
        ? data.agentsforFilter
        : data?.pocoHeartBeatTeam)?.map((agentData: any) => ({
          label: agentData.name,
          value: agentData.email,
        }));
    }
  });

  const { data: companyList } = useQuery({
    queryKey: ["getAllOffices"],
    queryFn: getAllCompany,
    select: (data: any) =>
      data.map((company: any) => ({
        value: company._id,
        label: company.companyName,
      })),
  });



  useEffect(() => {
    filterDate(filterCriteria);

    //eslint-disable-next-line
  }, [filterCriteria]);




  return {
    btnRef,
    handleSendDate,
    filterCriteria,
    handleGetTicketStatus,
    handleSelectAgent,
    handleSelectCompany,
    handleClearFilter,
    handleTicketID,
    handleCallerID,
    handleCaseStudiesToggle,
    data,
    companyList,
  };
};
